"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getActionName = exports.getReadableMallocErrorMessage = exports.getReadableErrorMessage = void 0;
const getReadableErrorMessage = (error, opts) => {
    if (error.mallocErrorMarker) {
        return (0, exports.getReadableMallocErrorMessage)(error, opts);
    }
    else {
        return JSON.stringify(error);
    }
};
exports.getReadableErrorMessage = getReadableErrorMessage;
const getReadableMallocErrorMessage = (error, opts) => {
    switch (error.type) {
        case "Malloc Action Builder":
            return `Build Error for ${(0, exports.getActionName)(error.actionIndex, opts)}: ${error.message}`;
        case "Malloc Compiler":
            return `Compilation to Solana Error: ${error.message}`;
        case "Malloc Runner":
            return `Runtime Error: ${error.message}`;
        case "Malloc Builder":
            return `Build Error: ${error.message}`;
        default:
            break;
    }
    return ``;
};
exports.getReadableMallocErrorMessage = getReadableMallocErrorMessage;
const getActionName = (actionIdx, opts) => opts.actionNames ? opts.actionNames[actionIdx] : `Action ${actionIdx + 1}`;
exports.getActionName = getActionName;
